import { pull } from 'lodash';
import { assocArrayLength, toStringAssoc } from '../../../../lib/utility/helpers';

export default function createBaseLayer (model, self = {}) {
  self.isSelected = function () {
    return model.Selected;
  };

  self.get = function (key) {
    return model[key];
  };
  self.set = function (key, value) {
    model[key] = value;
  };

  self.model = model;

  /**
     * Generates a layer ('Annotation') XML node;
     * @returns {string}
     */
  self.buildXML = function () {
    return '<Annotation ' +
        `Id="${model.Id}" ` +
        `Name="${model.Name}" ` +
        `Type="${model.Type}" ` +
        `Selected="${(model.Selected ? 1 : 0)}" ` +
        `Incremental="${(model.Incremental ? 1 : 0)}" ` +
        `LineColor="${model.LineColor}" ` + // note that layer color is saved BGR
        `Visible="${(model.isVisible ? 1 : 0)}" ` +

        // Funny story - without the extra parans this returns a bunch of undefined, and any save requests fail -- silently! TODO: Fix save logic.
        ((model.MacroName) ? `InputAnnotationId="${model.InputAnnotationId}" MacroName="${model.MacroName}"  MacroId="${model.MacroId}" ` : '') +

        'ReadOnly="0" NameReadOnly="0" LineColorReadOnly="0"></Annotation>';
  };

  self.addRegion = (region) => {
    if (!region.regionId) {
      throw new Error('cannot add unconstructed region to layer');
    }
    model.regions.push(region);
  };
  self.removeRegion = (region) => {
    pull(model.regions, region);
  };
  self.getRegion = (regionId) => model.regions.find(r => r.regionId === regionId);

  /* DEBUG CODE ONLY - TODO: REMOVE */
  self.toString = function (bReportResults) {
    var str = toStringAssoc(model);
    if (bReportResults && assocArrayLength(model.attributes)) {
      str += '\n              ..... Layer Results (' + assocArrayLength(model.attributes) + '):  ' + toStringAssoc(model.attributes);
    }
    return str;
  };

  self.toStringShort = function () {
    return 'Name: ' + model.Name + ' Id: ' + model.Id + ' typeName: ' + model.typeName +
            ((model.InputAnnotationId) ? ' InputAnnotationId: ' + model.InputAnnotationId + ' MacroName: ' + model.MacroName : '');
  };

  return self;
}



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/annotations/layer/types/base-layer.js